import { render, staticRenderFns } from "./aorderdetail.vue?vue&type=template&id=2503ec8e&scoped=true"
import script from "./aorderdetail.vue?vue&type=script&lang=js"
export * from "./aorderdetail.vue?vue&type=script&lang=js"
import style0 from "./aorderdetail.vue?vue&type=style&index=0&id=2503ec8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2503ec8e",
  null
  
)

export default component.exports